export default "__VITE_ASSET__B$rm9bRx__"